// = Libs =
import React from 'react';
import { Route, Switch } from 'react-router-dom';
// @ts-ignore
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

// = Imports =
import routes from '../routes';

const App: React.FC = () => {
  return (
    <>
      <Switch>
        {routes.map((route) => (
          <Route {...route} />
        ))}
      </Switch>
      <NotificationContainer />
    </>
  );
};

export default App;
